var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "retencao" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", [
                _c("h2", { staticClass: "mb-0" }, [
                  _vm._v("Retenção de Distribuidores")
                ]),
                _vm._v(" "),
                _vm.competencia
                  ? _c("small", { staticClass: "text-muted" }, [
                      _vm._v(
                        "\n          Ativos em " +
                          _vm._s(
                            _vm.formataData(_vm.competencia.data_referencia)
                          ) +
                          " · atualizado pelo Protheus em\n          " +
                          _vm._s(
                            _vm.formataDataHora(_vm.competencia.apurado_em)
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "mt-2 mt-md-0",
                  attrs: { cols: "12", md: "auto" }
                },
                [
                  _vm.podeCadastrarMeta
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mr-3",
                          attrs: {
                            variant: "outline-primary",
                            size: "sm",
                            href: "/adm/retencao/metas"
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-bullseye" }),
                          _vm._v(" Metas das analistas\n        ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticClass: "mb-0 mr-2" }, [
                    _vm._v("Competência")
                  ]),
                  _vm._v(" "),
                  _c("b-form-select", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      options: _vm.competencias.map(function(c) {
                        return { value: c, text: _vm.nomeCompetencia(c) }
                      }),
                      size: "sm",
                      disabled: _vm.loading
                    },
                    on: {
                      change: function($event) {
                        return _vm.carregar()
                      }
                    },
                    model: {
                      value: _vm.competenciaSel,
                      callback: function($$v) {
                        _vm.competenciaSel = $$v
                      },
                      expression: "competenciaSel"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading && !_vm.competencia
            ? _c(
                "div",
                { staticClass: "text-center my-5" },
                [_c("b-spinner")],
                1
              )
            : !_vm.competencia
            ? _c("div", { staticClass: "text-center text-muted my-5" }, [
                _vm._v(
                  "\n      Nenhuma competência recebida do Protheus ainda (job U_JOBRETEN).\n    "
                )
              ])
            : [
                _c("div", { staticClass: "mt-3 mb-1 text-muted small" }, [
                  _vm._v(
                    "\n        Meta " +
                      _vm._s(
                        _vm.regiaoMeta
                          ? "da Região " + _vm.regiaoMeta
                          : "de todas as regiões"
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "resumo" },
                  [
                    _c("b-col", { attrs: { cols: "6", md: "3" } }, [
                      _c("div", { staticClass: "card-resumo" }, [
                        _c("div", { staticClass: "titulo" }, [
                          _vm._v("Ativos")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "valor" }, [
                          _vm._v(_vm._s(_vm.resumo.ativos))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "det" }, [
                          _vm._v(
                            "Master " +
                              _vm._s(_vm.resumo.ativosA) +
                              " · Gestora " +
                              _vm._s(_vm.resumo.ativosG)
                          )
                        ]),
                        _vm._v(" "),
                        _vm.foraBase.novos || _vm.foraBase.reativados
                          ? _c(
                              "div",
                              { staticClass: "det" },
                              [
                                _vm._v(
                                  "\n              + fora da meta em " +
                                    _vm._s(
                                      _vm.rotuloMesSo(_vm.mesCompetencia)
                                    ) +
                                    ":\n              "
                                ),
                                _vm.foraBase.novos
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.filtrarMes("cadastro")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.foraBase.novos) +
                                            " novo(s)"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.foraBase.novos && _vm.foraBase.reativados
                                  ? [_vm._v(" · ")]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.foraBase.reativados
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.filtrarMes("reativacao")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.foraBase.reativados) +
                                            " reativado(s)\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "6", md: "3" } }, [
                      _c("div", { staticClass: "card-resumo verde" }, [
                        _c("div", { staticClass: "titulo" }, [
                          _vm._v("Retidos")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "valor" }, [
                          _vm._v(_vm._s(_vm.resumo.retidos))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "det" }, [
                          _vm._v(
                            "Master " +
                              _vm._s(_vm.resumo.retidosA) +
                              " · Gestora " +
                              _vm._s(_vm.resumo.retidosG)
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "6", md: "3" } }, [
                      _c("div", { staticClass: "card-resumo vermelho" }, [
                        _c("div", { staticClass: "titulo" }, [
                          _vm._v("Não retidos")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "valor" }, [
                          _vm._v(_vm._s(_vm.resumo.ativos - _vm.resumo.retidos))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "det" }, [
                          _vm._v(
                            _vm._s(_vm.resumo.semMotivo) +
                              " sem motivo registrado"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "6", md: "3" } }, [
                      _c(
                        "div",
                        { staticClass: "card-resumo" },
                        [
                          _c("div", { staticClass: "titulo" }, [
                            _vm._v("% Retenção")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "valor" }, [
                            _vm._v(_vm._s(_vm.formataPct(_vm.resumo.pct)))
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-progress",
                            {
                              staticClass: "mt-1",
                              attrs: { max: 100, height: "6px" }
                            },
                            [
                              _c("b-progress-bar", {
                                attrs: {
                                  value: _vm.resumo.pct,
                                  variant:
                                    _vm.faixas.length &&
                                    _vm.resumo.pct >= _vm.faixas[0].meta
                                      ? "success"
                                      : "danger"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "12", lg: "6" } }, [
                      _c("div", { staticClass: "card-resumo" }, [
                        _c("div", { staticClass: "titulo" }, [
                          _vm._v(
                            "\n              Metas " +
                              _vm._s(
                                _vm.nomeCompetencia(_vm.competencia.competencia)
                              ) +
                              "\n              "
                          ),
                          _vm.metaAnalista
                            ? _c("span", { staticClass: "text-lowercase" }, [
                                _vm._v("· " + _vm._s(_vm.metaAnalista.nome))
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.faixas.length
                          ? _c("div", { staticClass: "faixas-wrap" }, [
                              _c("table", { staticClass: "faixas" }, [
                                _c(
                                  "tr",
                                  [
                                    _c("th"),
                                    _vm._v(" "),
                                    _vm._l(_vm.faixas, function(f) {
                                      return _c(
                                        "th",
                                        {
                                          key: "p" + f.faixa,
                                          class: { batida: f.faltam <= 0 }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                f.premio !== null
                                                  ? _vm.formataReal(f.premio)
                                                  : f.faixa + "ª faixa"
                                              ) +
                                              "\n                    "
                                          ),
                                          f.faltam <= 0
                                            ? _c("i", {
                                                staticClass: "fas fa-check"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  [
                                    _c("td", [_vm._v("Precisa reter")]),
                                    _vm._v(" "),
                                    _vm._l(_vm.faixas, function(f) {
                                      return _c(
                                        "td",
                                        {
                                          key: "n" + f.faixa,
                                          staticClass: "ok"
                                        },
                                        [_vm._v(_vm._s(f.precisa))]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  [
                                    _c("td", [_vm._v("Faltam")]),
                                    _vm._v(" "),
                                    _vm._l(_vm.faixas, function(f) {
                                      return _c(
                                        "td",
                                        {
                                          key: "f" + f.faixa,
                                          class: f.faltam <= 0 ? "ok" : "falta"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                f.faltam <= 0
                                                  ? "batida"
                                                  : f.faltam
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  [
                                    _c("td", [_vm._v("% atingido")]),
                                    _vm._v(" "),
                                    _vm._l(_vm.faixas, function(f) {
                                      return _c(
                                        "td",
                                        {
                                          key: "a" + f.faixa,
                                          staticClass: "atingido"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formataPct(f.atingido))
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  [
                                    _c("td", [_vm._v("Meta")]),
                                    _vm._v(" "),
                                    _vm._l(_vm.faixas, function(f) {
                                      return _c(
                                        "td",
                                        {
                                          key: "m" + f.faixa,
                                          staticClass: "ok"
                                        },
                                        [_vm._v(_vm._s(_vm.formataPct(f.meta)))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _vm.metasDaRegiao.length > 1
                                ? _c("div", { staticClass: "det mt-1" }, [
                                    _vm._v(
                                      "\n                Outras analistas da região: " +
                                        _vm._s(
                                          _vm.metasDaRegiao
                                            .filter(function(m) {
                                              return m !== _vm.metaAnalista
                                            })
                                            .map(function(m) {
                                              return m.nome
                                            })
                                            .join(", ")
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _c("div", { staticClass: "det mt-2" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.regiaoMeta
                                      ? "Meta não cadastrada para este mês."
                                      : "Escolha uma região para ver a meta."
                                  ) +
                                  "\n            "
                              )
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "12", lg: "6" } }, [
                      _c("div", { staticClass: "card-resumo" }, [
                        _c(
                          "div",
                          {
                            staticClass: "titulo d-flex justify-content-between"
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                Vendas digitadas · " +
                                  _vm._s(
                                    _vm.filtro.regiao
                                      ? "Região " + _vm.filtro.regiao
                                      : "todas as regiões"
                                  ) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "troca-metrica" }, [
                              _c(
                                "a",
                                {
                                  class: {
                                    ativo: _vm.metricaGrafico === "valor_mes"
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.metricaGrafico = "valor_mes"
                                    }
                                  }
                                },
                                [_vm._v("R$")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  class: {
                                    ativo: _vm.metricaGrafico === "qtd_mes"
                                  },
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.metricaGrafico = "qtd_mes"
                                    }
                                  }
                                },
                                [_vm._v("itens")]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "totais" }, [
                          _c("div", [
                            _c("div", { staticClass: "rot" }, [
                              _vm._v(_vm._s(_vm.rotuloMes(_vm.mesCompetencia)))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "num" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formataQtd(_vm.totais.mes.qtd) || "0"
                                ) + " "
                              ),
                              _c("small", [_vm._v("itens")])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "num-rs" }, [
                              _vm._v(
                                _vm._s(_vm.formataReal(_vm.totais.mes.valor))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: [
                                  "var",
                                  _vm.classeVar(_vm.totais.mes.varValor)
                                ],
                                attrs: {
                                  title:
                                    "Mesmo mês de " +
                                    _vm.anoAnterior +
                                    ": " +
                                    _vm.formataReal(_vm.totais.mes.valorAnt) +
                                    " · " +
                                    _vm.formataQtd(_vm.totais.mes.qtdAnt) +
                                    " itens"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.formataVar(_vm.totais.mes.varValor)
                                    ) +
                                    " R$ vs " +
                                    _vm._s(_vm.rotuloMes(_vm.mesAnoAnterior)) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: [
                                  "var",
                                  _vm.classeVar(_vm.totais.mes.varQtd)
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.formataVar(_vm.totais.mes.varQtd)
                                    ) +
                                    " itens (" +
                                    _vm._s(
                                      _vm.formataDif(
                                        _vm.totais.mes.qtd -
                                          _vm.totais.mes.qtdAnt
                                      )
                                    ) +
                                    ")\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "rot" }, [
                              _vm._v(
                                "Acumulado jan–" +
                                  _vm._s(_vm.rotuloMesSo(_vm.mesCompetencia)) +
                                  "/" +
                                  _vm._s(String(_vm.anoAtual).substr(2))
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "num" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formataQtd(_vm.totais.acum.qtd) || "0"
                                ) + " "
                              ),
                              _c("small", [_vm._v("itens")])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "num-rs" }, [
                              _vm._v(
                                _vm._s(_vm.formataReal(_vm.totais.acum.valor))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: [
                                  "var",
                                  _vm.classeVar(_vm.totais.acum.varValor)
                                ],
                                attrs: {
                                  title:
                                    "Mesmo período de " +
                                    _vm.anoAnterior +
                                    ": " +
                                    _vm.formataReal(_vm.totais.acum.valorAnt) +
                                    " · " +
                                    _vm.formataQtd(_vm.totais.acum.qtdAnt) +
                                    " itens"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.formataVar(_vm.totais.acum.varValor)
                                    ) +
                                    " R$ vs jan–" +
                                    _vm._s(
                                      _vm.rotuloMesSo(_vm.mesCompetencia)
                                    ) +
                                    "/" +
                                    _vm._s(String(_vm.anoAnterior).substr(2)) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class: [
                                  "var",
                                  _vm.classeVar(_vm.totais.acum.varQtd)
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.formataVar(_vm.totais.acum.varQtd)
                                    ) +
                                    " itens (" +
                                    _vm._s(
                                      _vm.formataDif(
                                        _vm.totais.acum.qtd -
                                          _vm.totais.acum.qtdAnt
                                      )
                                    ) +
                                    ")\n                "
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "grafico",
                            attrs: {
                              viewBox:
                                "0 0 " +
                                _vm.grafico.largura +
                                " " +
                                _vm.grafico.altura
                            }
                          },
                          [
                            _c("line", {
                              staticClass: "eixo",
                              attrs: {
                                x1: 0,
                                x2: _vm.grafico.largura,
                                y1: _vm.grafico.base,
                                y2: _vm.grafico.base
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.grafico.barras, function(b) {
                              return _c("g", { key: b.mes }, [
                                _c(
                                  "rect",
                                  {
                                    staticClass: "b-ant",
                                    attrs: {
                                      x: b.x,
                                      y: b.yAnt,
                                      width: b.w,
                                      height: _vm.grafico.base - b.yAnt
                                    }
                                  },
                                  [_c("title", [_vm._v(_vm._s(b.rotuloAnt))])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "rect",
                                  {
                                    class: ["b-atu", { atual: b.atual }],
                                    attrs: {
                                      x: b.x + b.w + 2,
                                      y: b.yAtu,
                                      width: b.w,
                                      height: _vm.grafico.base - b.yAtu
                                    }
                                  },
                                  [_c("title", [_vm._v(_vm._s(b.rotuloAtu))])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "text",
                                  {
                                    staticClass: "rot-mes",
                                    attrs: {
                                      x: b.x + b.w + 1,
                                      y: _vm.grafico.altura - 3
                                    }
                                  },
                                  [_vm._v(_vm._s(b.nome))]
                                ),
                                _vm._v(" "),
                                b.difQtd !== null
                                  ? _c(
                                      "text",
                                      {
                                        class: [
                                          "dif",
                                          b.difQtd >= 0 ? "sobe" : "desce"
                                        ],
                                        attrs: {
                                          x: b.x + b.w + 1,
                                          y: Math.min(b.yAnt, b.yAtu) - 4
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(b.difCurta) +
                                            "\n                  "
                                        ),
                                        _c("title", [
                                          _vm._v(_vm._s(b.rotuloDif))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "legenda-graf" }, [
                          _c("span", [
                            _c("i", { staticClass: "b-ant" }),
                            _vm._v(" " + _vm._s(_vm.anoAnterior))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _c("i", { staticClass: "b-atu" }),
                            _vm._v(" " + _vm._s(_vm.anoAtual))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-muted" }, [
                            _vm._v("· mesmos distribuidores da base de ativos")
                          ])
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.resumo.motivos.length
                  ? _c(
                      "div",
                      { staticClass: "motivos mt-2" },
                      [
                        _c("span", { staticClass: "text-muted small mr-2" }, [
                          _vm._v("Motivos:")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.resumo.motivos, function(m) {
                          return _c(
                            "b-badge",
                            {
                              key: m.motivo,
                              staticClass: "mr-1 mb-1 motivo-badge",
                              attrs: {
                                variant:
                                  _vm.filtro.motivo === m.motivo
                                    ? "primary"
                                    : "light"
                              },
                              on: {
                                click: function($event) {
                                  _vm.filtro.motivo =
                                    _vm.filtro.motivo === m.motivo
                                      ? null
                                      : m.motivo
                                }
                              }
                            },
                            [
                              _vm._v("\n          " + _vm._s(m.motivo) + " "),
                              _c("b", [_vm._v(_vm._s(m.qtd))]),
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formataPct(
                                      (m.qtd / _vm.resumo.ativos) * 100
                                    )
                                  ) +
                                  ")\n        "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mt-3", attrs: { "align-v": "end" } },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "6", md: "2" } },
                      [
                        _c("label", [_vm._v("Região")]),
                        _vm._v(" "),
                        _c("b-form-select", {
                          attrs: { options: _vm.opcoesRegiao, size: "sm" },
                          model: {
                            value: _vm.filtro.regiao,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "regiao", $$v)
                            },
                            expression: "filtro.regiao"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6", md: "1" } },
                      [
                        _c("label", [_vm._v("Classe")]),
                        _vm._v(" "),
                        _c("b-form-select", {
                          attrs: { options: _vm.opcoesClasse, size: "sm" },
                          model: {
                            value: _vm.filtro.classe,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "classe", $$v)
                            },
                            expression: "filtro.classe"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6", md: "2" } },
                      [
                        _c("label", [_vm._v("Retenção")]),
                        _vm._v(" "),
                        _c("b-form-select", {
                          attrs: { options: _vm.opcoesRetido, size: "sm" },
                          model: {
                            value: _vm.filtro.retido,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "retido", $$v)
                            },
                            expression: "filtro.retido"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6", md: "1" } },
                      [
                        _c("label", [_vm._v("Semana")]),
                        _vm._v(" "),
                        _c("b-form-select", {
                          attrs: { options: _vm.opcoesSemana, size: "sm" },
                          model: {
                            value: _vm.filtro.semana,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "semana", $$v)
                            },
                            expression: "filtro.semana"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6", md: "2" } },
                      [
                        _c("label", [_vm._v("Cadastro")]),
                        _vm._v(" "),
                        _c("b-form-select", {
                          attrs: {
                            options: _vm.opcoesPeriodo("cadastro"),
                            size: "sm"
                          },
                          model: {
                            value: _vm.filtro.cadastro,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "cadastro", $$v)
                            },
                            expression: "filtro.cadastro"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "6", md: "2" } },
                      [
                        _c("label", [_vm._v("Reativação")]),
                        _vm._v(" "),
                        _c("b-form-select", {
                          attrs: {
                            options: _vm.opcoesPeriodo("reativacao"),
                            size: "sm"
                          },
                          model: {
                            value: _vm.filtro.reativacao,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "reativacao", $$v)
                            },
                            expression: "filtro.reativacao"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "2" } },
                      [
                        _c("label", [_vm._v("Busca")]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          attrs: {
                            size: "sm",
                            placeholder:
                              "Código, nome, cidade, consultor ou motivo",
                            debounce: "300"
                          },
                          model: {
                            value: _vm.filtro.busca,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "busca", $$v)
                            },
                            expression: "filtro.busca"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "text-md-right mt-2",
                        attrs: { cols: "12" }
                      },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "d-inline-block mr-3",
                            attrs: { switch: "", size: "sm" },
                            model: {
                              value: _vm.mostraAnoAnterior,
                              callback: function($$v) {
                                _vm.mostraAnoAnterior = $$v
                              },
                              expression: "mostraAnoAnterior"
                            }
                          },
                          [
                            _vm._v(
                              "\n            Meses de " +
                                _vm._s(_vm.anoAnterior) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "success",
                              size: "sm",
                              disabled: _vm.loading
                            },
                            on: {
                              click: function($event) {
                                return _vm.exportar()
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "far fa-file-excel" }),
                            _vm._v(" Exportar Excel\n          ")
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-wrap justify-content-between align-items-center mt-3 mb-2"
                  },
                  [
                    _c("div", { staticClass: "small text-muted" }, [
                      _c("b", [_vm._v(_vm._s(_vm.filtrados.length))]),
                      _vm._v(" distribuidor(es)\n          "),
                      _vm.filtro.motivo
                        ? _c("span", [
                            _vm._v(
                              '\n            · motivo "' +
                                _vm._s(_vm.filtro.motivo) +
                                '"\n            '
                            ),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.filtro.motivo = null
                                  }
                                }
                              },
                              [_vm._v("limpar")]
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "legenda" }, [
                      _c("span", [
                        _c("i", { staticClass: "cel n0" }),
                        _vm._v(" sem pedido")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("i", { staticClass: "cel n1" }),
                        _vm._v(" abaixo da média")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("i", { staticClass: "cel n2" }),
                        _vm._v(" na média")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("i", { staticClass: "cel n3" }),
                        _vm._v(" acima da média")
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "grade" }, [
                  _c("table", { staticClass: "tabela" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticClass: "col-dist" }, [
                          _vm._v("Distribuidor")
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-hist" }, [
                          _c(
                            "div",
                            {
                              class: [
                                "hist",
                                { "com-ano": _vm.mostraAnoAnterior }
                              ]
                            },
                            [
                              _vm.mostraAnoAnterior
                                ? _c("span", { staticClass: "ano-cab" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                _vm.linhasHist[_vm.linhasHist.length - 1].meses,
                                function(m) {
                                  return _c(
                                    "span",
                                    {
                                      key: "h" + m,
                                      class: [
                                        "mes-cab",
                                        {
                                          atual:
                                            !_vm.mostraAnoAnterior &&
                                            m === _vm.mesCompetencia
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.mostraAnoAnterior
                                            ? _vm.rotuloMesSo(m)
                                            : _vm.rotuloMesCurto(m)
                                        )
                                      )
                                    ]
                                  )
                                }
                              )
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-num" }, [
                          _vm._v("Média"),
                          _c("br"),
                          _vm._v(_vm._s(_vm.anoAnterior))
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-num" }, [
                          _vm._v("Média"),
                          _c("br"),
                          _vm._v(_vm._s(_vm.anoAtual))
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-mes" }, [
                          _vm._v(_vm._s(_vm.rotuloMes(_vm.mesCompetencia)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "col-semana",
                            attrs: {
                              title:
                                "Semana do mês em que o distribuidor costuma comprar (R$ dos últimos 12 meses fechados)"
                            }
                          },
                          [
                            _vm._v("\n                Semana"),
                            _c("br"),
                            _vm._v("de compra\n              ")
                          ]
                        ),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-contato" }, [
                          _vm._v("Últ. contato")
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-motivo" }, [
                          _vm._v("Motivo s/ pedido")
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-obs" }, [
                          _vm._v("Observação")
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "col-cat",
                            attrs: {
                              title:
                                "Catálogos do último envio (Z46 com pedido gerado)"
                            }
                          },
                          [_vm._v("Catálogos")]
                        ),
                        _vm._v(" "),
                        _c("th", { staticClass: "col-opcat" }, [
                          _vm._v("Op. Cat")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        !_vm.filtrados.length
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "vazio",
                                  attrs: { colspan: "11" }
                                },
                                [_vm._v("Nenhum distribuidor encontrado")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.pagina, function(item) {
                          return _c(
                            "tr",
                            {
                              key: item.codigo,
                              class: [
                                item.fora_base
                                  ? "fora-base"
                                  : item.qtd_atual > 0
                                  ? "retido"
                                  : "nao-retido",
                                { bloqueado: !_vm.podeEditar(item) }
                              ]
                            },
                            [
                              _c("td", { staticClass: "col-dist" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "nome",
                                    attrs: { title: item.nome }
                                  },
                                  [_vm._v(_vm._s(item.nome))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "sub" }, [
                                  _c("span", { staticClass: "cod" }, [
                                    _vm._v(_vm._s(item.codigo))
                                  ]),
                                  _vm._v(
                                    " · " +
                                      _vm._s(item.cidade) +
                                      "/" +
                                      _vm._s(item.uf) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "tags" }, [
                                  _c(
                                    "span",
                                    { class: ["tag", "classe-" + item.classe] },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.nomeClasse(item.classe))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "tag" }, [
                                    _vm._v("Reg. " + _vm._s(item.regiao))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tag",
                                      attrs: { title: "Situação do cliente" }
                                    },
                                    [_vm._v("Sit. " + _vm._s(item.situacao))]
                                  ),
                                  _vm._v(" "),
                                  _vm.mesCadastro(item) >=
                                  _vm.mesAnteriorCompetencia
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "tag novo",
                                          attrs: {
                                            title:
                                              "Cadastrado em " +
                                              _vm.formataData(
                                                item.data_cadastro
                                              )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Novo " +
                                              _vm._s(
                                                _vm.rotuloMesSo(
                                                  _vm.mesCadastro(item)
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.mesReativacao(item) >=
                                  _vm.mesAnteriorCompetencia
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "tag reativado",
                                          attrs: {
                                            title:
                                              "Reativado em " +
                                              _vm.formataData(
                                                item.data_reativacao
                                              )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Reativado " +
                                              _vm._s(
                                                _vm.rotuloMesSo(
                                                  _vm.mesReativacao(item)
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.fora_base
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "tag fora",
                                          attrs: {
                                            title:
                                              "Entrou depois do fechamento da base: não conta na meta deste mês"
                                          }
                                        },
                                        [_vm._v("fora da meta")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.consultor
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "consultor",
                                          attrs: {
                                            title:
                                              "Consultor: " + item.consultor
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-user-tie"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(item.consultor) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "col-hist" },
                                _vm._l(_vm.linhasHist, function(linha) {
                                  return _c(
                                    "div",
                                    {
                                      key: "l" + linha.ano,
                                      class: [
                                        "hist",
                                        { "com-ano": _vm.mostraAnoAnterior }
                                      ]
                                    },
                                    [
                                      _vm.mostraAnoAnterior
                                        ? _c(
                                            "span",
                                            { staticClass: "ano-cab" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  String(linha.ano).substr(2)
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(linha.meses, function(m) {
                                        return _c(
                                          "span",
                                          {
                                            key: "c" + m,
                                            class: [
                                              "cel",
                                              m > _vm.mesCompetencia
                                                ? "futuro"
                                                : _vm.nivelMes(item, m),
                                              {
                                                atual: m === _vm.mesCompetencia
                                              }
                                            ],
                                            attrs: {
                                              title:
                                                m > _vm.mesCompetencia
                                                  ? ""
                                                  : _vm.dicaMes(item, m)
                                            }
                                          },
                                          [
                                            m <= _vm.mesCompetencia &&
                                            _vm.qtd(item, m)
                                              ? [
                                                  _c(
                                                    "span",
                                                    { staticClass: "q" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formataCurto(
                                                            _vm.qtd(item, m)
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.qtd(item, m, "valor_mes")
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "rs" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formataCurtoReal(
                                                                _vm.qtd(
                                                                  item,
                                                                  m,
                                                                  "valor_mes"
                                                                )
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      })
                                    ],
                                    2
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "col-num" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formataQtd(
                                        _vm.media(item, _vm.mesesAnterior)
                                      ) || "–"
                                    ) +
                                    "\n                "
                                ),
                                _vm.media(item, _vm.mesesAnterior, "valor_mes")
                                  ? _c("div", { staticClass: "valor" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formataReal(
                                              _vm.media(
                                                item,
                                                _vm.mesesAnterior,
                                                "valor_mes"
                                              )
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "col-num" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formataQtd(
                                        _vm.media(item, _vm.mesesAtual)
                                      ) || "–"
                                    ) +
                                    "\n                "
                                ),
                                _vm.media(item, _vm.mesesAtual, "valor_mes")
                                  ? _c("div", { staticClass: "valor" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formataReal(
                                              _vm.media(
                                                item,
                                                _vm.mesesAtual,
                                                "valor_mes"
                                              )
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "col-mes" }, [
                                _c("div", { staticClass: "qtd-mes" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formataQtd(item.qtd_atual) || "0"
                                    ) + " "
                                  ),
                                  _c("small", [_vm._v("itens")])
                                ]),
                                _vm._v(" "),
                                item.valor_atual > 0
                                  ? _c("div", { staticClass: "valor-mes" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formataReal(item.valor_atual)
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    class: [
                                      "selo",
                                      item.qtd_atual > 0 ? "sim" : "nao"
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          item.qtd_atual > 0
                                            ? "Retido"
                                            : "Não retido"
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "col-semana" },
                                [
                                  item.semana
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              "semana",
                                              {
                                                hoje:
                                                  item.semana === _vm.semanaHoje
                                              }
                                            ],
                                            attrs: {
                                              title: _vm.dicaSemana(item)
                                            }
                                          },
                                          [
                                            _c("b", [
                                              _vm._v(_vm._s(item.semana) + "ª")
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "dias" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.diasSemana(item.semana)
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "barras",
                                            attrs: {
                                              title: _vm.dicaSemana(item)
                                            }
                                          },
                                          _vm._l(item.semana_pct, function(
                                            p,
                                            i
                                          ) {
                                            return _c("span", {
                                              key: "s" + i,
                                              class: [
                                                "barra",
                                                { topo: i + 1 === item.semana }
                                              ],
                                              style: {
                                                height:
                                                  Math.max(
                                                    2,
                                                    Math.round((p / 100) * 24)
                                                  ) + "px"
                                              }
                                            })
                                          }),
                                          0
                                        ),
                                        _vm._v(" "),
                                        item.semana === _vm.semanaHoje
                                          ? _c(
                                              "div",
                                              { staticClass: "cobrar" },
                                              [_vm._v("semana atual")]
                                            )
                                          : _vm._e()
                                      ]
                                    : _c("span", { staticClass: "sub" }, [
                                        _vm._v("–")
                                      ])
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "col-contato" },
                                [
                                  item.data_contato
                                    ? [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formataData(item.data_contato)
                                            ) +
                                            "\n                  "
                                        ),
                                        item.contato_em
                                          ? _c("div", { staticClass: "hora" }, [
                                              _vm._v(
                                                _vm._s(
                                                  String(
                                                    item.contato_em
                                                  ).substr(11, 5)
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "sub",
                                            attrs: {
                                              title: item.contato_usuario
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.primeiroNome(
                                                  item.contato_usuario
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    : _c("span", { staticClass: "sub" }, [
                                        _vm._v("–")
                                      ])
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "col-motivo" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.motivo,
                                      expression: "item.motivo"
                                    }
                                  ],
                                  staticClass: "campo",
                                  attrs: {
                                    list: "retencao-motivos",
                                    maxlength: "255",
                                    placeholder: "Informar motivo…",
                                    readonly: !_vm.podeEditar(item),
                                    title: _vm.podeEditar(item)
                                      ? ""
                                      : "Fora da sua região (somente leitura)"
                                  },
                                  domProps: { value: item.motivo },
                                  on: {
                                    change: function($event) {
                                      return _vm.salvar(item)
                                    },
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return $event.target.blur()
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item,
                                        "motivo",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "col-obs" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.observacao,
                                          expression: "item.observacao"
                                        }
                                      ],
                                      staticClass: "campo",
                                      attrs: {
                                        maxlength: "2000",
                                        placeholder: "Observação…",
                                        readonly: !_vm.podeEditar(item),
                                        title: _vm.podeEditar(item)
                                          ? item.observacao
                                          : "Fora da sua região (somente leitura)"
                                      },
                                      domProps: { value: item.observacao },
                                      on: {
                                        change: function($event) {
                                          return _vm.salvar(item)
                                        },
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return $event.target.blur()
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            item,
                                            "observacao",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "col-cat" },
                                [
                                  item.catalogos !== null &&
                                  item.catalogos !== undefined
                                    ? [
                                        _c("div", { staticClass: "qtd-cat" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formataQtd(item.catalogos) ||
                                                "0"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        item.catalogo_data
                                          ? _c("div", { staticClass: "sub" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formataData(
                                                    item.catalogo_data
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    : _c("span", { staticClass: "sub" }, [
                                        _vm._v("–")
                                      ])
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "col-opcat" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.op_cat,
                                          expression: "item.op_cat"
                                        }
                                      ],
                                      staticClass: "campo",
                                      attrs: {
                                        maxlength: "30",
                                        placeholder: "Op. Cat…",
                                        readonly: !_vm.podeEditar(item),
                                        title: _vm.podeEditar(item)
                                          ? ""
                                          : "Fora da sua região (somente leitura)"
                                      },
                                      domProps: { value: item.op_cat },
                                      on: {
                                        change: function($event) {
                                          return _vm.salvar(item)
                                        },
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return $event.target.blur()
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            item,
                                            "op_cat",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "status" },
                                      [
                                        item._salvando
                                          ? _c("b-spinner", {
                                              attrs: { small: "" }
                                            })
                                          : item._salvo
                                          ? _c("i", {
                                              staticClass:
                                                "fas fa-check-circle text-success",
                                              attrs: { title: "Salvo" }
                                            })
                                          : item._erro
                                          ? _c("i", {
                                              staticClass:
                                                "fas fa-exclamation-triangle text-danger",
                                              attrs: { title: item._erro }
                                            })
                                          : !_vm.podeEditar(item)
                                          ? _c("i", {
                                              staticClass:
                                                "fas fa-lock text-muted",
                                              attrs: {
                                                title: "Fora da sua região"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "datalist",
                  { attrs: { id: "retencao-motivos" } },
                  _vm._l(_vm.motivos, function(m) {
                    return _c("option", { key: m, domProps: { value: m } })
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.filtrados.length > _vm.porPagina
                  ? _c(
                      "b-row",
                      { staticClass: "mt-2" },
                      [
                        _c(
                          "b-col",
                          [
                            _c("b-pagination", {
                              attrs: {
                                "total-rows": _vm.filtrados.length,
                                "per-page": _vm.porPagina,
                                size: "sm"
                              },
                              model: {
                                value: _vm.paginaAtual,
                                callback: function($$v) {
                                  _vm.paginaAtual = $$v
                                },
                                expression: "paginaAtual"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be904394", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be904394","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_retencao/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-be904394","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_retencao/Index.vue
// module chunks = 2